import PropTypes from 'prop-types';
import { PrimaryButton, SecondaryButton } from 'jl-design-system/elements/button/Button';
import classnames from 'classnames';

import styles from './FormEditButtons.scss';

export const EditModeNavButtons = ({
  cancelHandler,
  previousButtonHandler,
  saveEditingHandler,
  extraClassName = '',
  saveButtonText = 'Next',
  hideGoBackButton = false,
}) => (
  <div className={[styles.FormEditButtons, extraClassName].join(' ')} data-testid="FormEditButtons">
    {saveEditingHandler && (
      <PrimaryButton inline className={styles.WarningSaveButton} onClick={saveEditingHandler}>
        {saveButtonText}
      </PrimaryButton>
    )}
    {!hideGoBackButton && (
      <SecondaryButton
        inline
        className={styles.WarningCancelButton}
        onClick={previousButtonHandler}
      >
        Go back
      </SecondaryButton>
    )}
    <SecondaryButton
      className={classnames(styles.CancelDetail, { [styles.StickLeft]: hideGoBackButton })}
      onClick={cancelHandler}
    >
      Cancel
    </SecondaryButton>
  </div>
);

EditModeNavButtons.propTypes = {
  cancelHandler: PropTypes.func.isRequired,
  saveEditingHandler: PropTypes.func,
  previousButtonHandler: PropTypes.func.isRequired,
  extraClassName: PropTypes.string,
  saveButtonText: PropTypes.string,
  hideGoBackButton: PropTypes.bool,
};
